import { Injectable, Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { MenuItem } from '@awp/models';
import { MenuService, MENU_TOKEN } from '@awp/app-common';

@Injectable({
  providedIn: 'root'
})
export class MenuContentResolver implements Resolve<any> {

  constructor(
    @Inject(MENU_TOKEN) private menuService: MenuService,
    private contentProvider: ContentProvider) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const menuId = route.paramMap.get('menuId');

    return this.menuService.values.pipe(
      map(items => {
        const page = items.find(i => i.url === menuId);
        if (page == null) {
          console.warn(`Page '${menuId}' not found`);
        }
        return page;
      }),
      switchMap((menu: MenuItem) => {
        return menu != null && menu.contentUrl != null
          ? this.contentProvider.fetchContent(menu.contentUrl)
          : EMPTY;
      }),
      take(1)
    );
  }

}
